import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'button-block',
  styleUrl: 'button-block.css',
  shadow: false,
})
export class ButtonBlock {
  @Prop() buttonsData: { cta: string; text: string; type: string; target:string, color:string;}[];

  render() {
    //console.log(this.buttonsData);
    return (
      <Host>

        {this.buttonsData['cta'] && (
          <a href={this.buttonsData['cta']} target={this.buttonsData['target']} class={`button cursor-pointer ${this.buttonsData['type']} ${this.buttonsData['color']}`}>
            {this.buttonsData['text']}
          </a>
        )}
        
      </Host>
    );
  }
}
